import { __extends } from "tslib";
import { clearHighlight, setHighlightBy } from './highlight-util';
import ElementRangeState from './range-state';
/**
 * @ignore
 * 区域 highlight 的 Action
 */
var ElementRangeHighlight = /** @class */ (function (_super) {
    __extends(ElementRangeHighlight, _super);
    function ElementRangeHighlight() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.stateName = 'active';
        return _this;
    }
    // 清理掉所有的 active， unactive 状态
    ElementRangeHighlight.prototype.clearViewState = function (view) {
        clearHighlight(view);
    };
    /**
     * 设置 highlight
     */
    ElementRangeHighlight.prototype.highlight = function () {
        this.setState();
    };
    ElementRangeHighlight.prototype.setElementsState = function (elements, enable, allElements) {
        setHighlightBy(allElements, function (el) { return elements.indexOf(el) >= 0; }, enable);
    };
    return ElementRangeHighlight;
}(ElementRangeState));
export default ElementRangeHighlight;
//# sourceMappingURL=range-highlight.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2@4.0.15@@antv/g2/esm/interaction/action/element/range-highlight.js
// module id = null
// module chunks = 